import { render, staticRenderFns } from "./GeneralMenuItem.vue?vue&type=template&id=753b5162&scoped=true"
import script from "./GeneralMenuItem.vue?vue&type=script&lang=js"
export * from "./GeneralMenuItem.vue?vue&type=script&lang=js"
import style0 from "./GeneralMenuItem.vue?vue&type=style&index=0&id=753b5162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b5162",
  null
  
)

export default component.exports